import { Link } from 'react-router-dom';

const faqs = [
  {
    question: '073漫画网的漫画都是免费的吗？',
    answer: '是的！073漫画网上的所有漫画均完全免费，无需注册、无需付费，打开即可畅享阅读体验。我们致力于为广大漫友提供最便捷的在线漫画阅读服务。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画是一种创新的阅读方式，您只需向下滚动页面即可连续阅读漫画章节，无需翻页或点击。这种方式操作简便、加载快速，让追漫体验更加流畅自然。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们的编辑团队会密切关注每部漫画的更新动态，确保第一时间同步最新章节。热门漫画通常每周更新1-2话，具体更新频率取决于原作者的发稿节奏。',
  },
  {
    question: '手机可以阅读漫画吗？',
    answer: '当然可以！073漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得优质的阅读体验。下拉式阅读在手机上同样流畅。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型的漫画，也可以使用顶部搜索框直接搜索漫画名称。首页的热门推荐和最新更新板块也能帮您发现好漫画。',
  },
];

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-label="关于我们">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-xs font-medium text-primary-600 uppercase tracking-widest">
            About
          </span>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-foreground-950 mt-2">
            关于073漫画网
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl mx-auto leading-relaxed">
            073漫画网是一个专注于提供优质漫画在线阅读的平台。我们以"操作便捷、加载快速、追漫不受限制"为核心理念，
            致力于为广大漫画爱好者打造最舒适的在线漫画阅读体验。无论你身在何处，只需打开浏览器，就能畅享精彩漫画世界。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mb-14">
          <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-flashlight-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">加载快速</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              采用先进的技术架构，漫画页面加载速度极快，下拉式阅读流畅无卡顿，给你丝滑般的追漫体验。
            </p>
          </div>
          <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
              <i className="ri-book-open-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">内容丰富</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              涵盖治愈、科幻、仙侠、悬疑、冒险等多种类型，持续更新热门漫画，满足不同读者的阅读喜好。
            </p>
          </div>
          <div className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
              <i className="ri-device-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">多端适配</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              完美支持电脑、平板、手机等各类设备，随时随地打开浏览器就能看漫画，追漫不受设备和场景限制。
            </p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto">
          <h3 className="text-xl md:text-2xl font-display font-bold text-foreground-950 mb-6 text-center">
            常见问题
          </h3>
          <div className="flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group rounded-lg bg-background-100 border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors inline-flex items-center gap-1.5"
          >
            了解更多关于我们
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}